export class LotCharactsRequest {
    public lot_number;
    public language;
}



// WEBPACK FOOTER //
// ./src/app/model/lot/lot_characts_request.model.ts